import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const API = process.env.REACT_APP_BACKEND_URL;

// Honest live numbers (no fabricated activity). Hides any figure that is still zero.
export const ImpactStrip = ({ colors }) => {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/public/impact-stats`).then((r) => (r.ok ? r.json() : null)).then(setStats).catch(() => {});
  }, []);
  if (!stats) return null;
  if (!stats.members || stats.members < 500) return null;
  const items = [
    ['members', 'people have walked in the door'],
    ['conversations', 'conversations with a companion'],
    ['weeks_completed', 'course weeks completed'],
    ['prayers', 'prayers lifted on the wall'],
  ].filter(([k]) => stats[k] > 0);
  if (!items.length) return null;
  const navy = colors?.navy || '#1B2A41';
  const sage = colors?.sage || '#8A9A86';
  return (
    <section data-testid="impact-strip" style={{ background: '#fff', borderBottom: `1px solid ${sage}33` }}>
      <div className="container mx-auto px-6" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem 3rem', padding: '1.5rem 1.5rem' }}>
        {items.map(([k, label], i) => (
          <motion.div key={k} data-testid={`impact-${k}`} initial={{ opacity: 0, y: 8 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }} style={{ textAlign: 'center', minWidth: 140 }}>
            <div style={{ fontFamily: "'Manrope', sans-serif", fontSize: '1.9rem', fontWeight: 800, color: navy, lineHeight: 1 }}>{stats[k].toLocaleString()}{stats[k] >= 100 ? '+' : ''}</div>
            <div style={{ fontSize: '0.8rem', color: '#4B5563', marginTop: 4 }}>{label}</div>
          </motion.div>
        ))}
        <div style={{ alignSelf: 'center', fontSize: '0.72rem', color: '#9CA3AF', flexBasis: '100%', textAlign: 'center' }}>Live figures from this ministry — small, honest, and growing.</div>
      </div>
    </section>
  );
};
